export const leadershipRolesData = [
    {
        title: "Coach",
        description: "Focuses on team behavior and development",
        categories: [
            {
                name: "Knowledge",
                items: ["Understand Team Roles", "Motivation Theory (e.g. Herzberg)", "Psychological Safety", "Feedback Culture & Conflicts"]
            },
            {
                name: "Skills",
                items: ["Identify team dynamics", "Build trust", "Provide feedback", "Uncover missing behavior", "Surface conflicts"]
            },
            {
                name: "Values & Attitude",
                items: ["Role model for feedback", "Develop leadership in others", "Coach towards positive conflict culture"]
            }
        ],
        tasks: [
            "Observes team members",
            "Uncovers which kind of behavior is missing in a team to improve teamwork",
            "Provides feedback",
            "Builds team trust",
            "Helps team to find out what they wish to change",
            "Helps team to find out how to change",
            "Brings developing conflicts to the surface"
        ]
    },
    {
        title: "Knowledge Enabler",
        description: "Ensures expertise and learning flow",
        categories: [
            {
                name: "Knowledge",
                items: ["Understand team knowledge needs"]
            },
            {
                name: "Skills",
                items: ["Visualizing & structuring information", "Support knowledge acquisition", "Facilitate exchange meetings", "Foster peer learning"]
            },
            {
                name: "Values & Attitude",
                items: ["Role model for knowledge gaps", "Establish positive failure culture", "Promote iterative learning"]
            }
        ],
        tasks: [
            "Realizes which kind of knowledge the team needs (e.g. expert information, methodological skills)",
            "Supports team members to acquire new knowledge",
            "Visualizes information",
            "Send team members to trainings",
            "Send team members to conferences",
            "Schedules knowledge exchange meetings",
            "Promotes iterative learning (e.g. learning from mistakes, fosters learning-by-doing)",
            "Urges team to take time for learning",
            "Fosters learning from each other"
        ]
    },
    {
        title: "Helicopter",
        description: "Maintains the big picture and structural links",
        categories: [
            {
                name: "Knowledge",
                items: ["See bigger picture", "Difference between Goals (OKR) & Work items", "Ceremonies & Workflows"]
            },
            {
                name: "Skills",
                items: ["Understand project goals", "Jointly formulate team goals", "Structure work & backlog", "Prepare PACE ceremonies", "Support stakeholder management"]
            }
        ],
        tasks: [
            "Possesses the ability to see the bigger picture",
            "Knows who possesses the skill for a certain task",
            "Identifies links between individuals and tasks from different technical expertise or domains towards a common goal",
            "Includes relevant stakeholders",
            "Structures work",
            "Be quick in handing over the work to another professional of another expertise"
        ]
    },
    {
        title: "Method Champion",
        description: "Guardian of the agile process",
        categories: [
            {
                name: "Knowledge",
                items: ["Agile Manifesto", "Frameworks (Scrum, Kanban, XP, SAFe, OKR)", "Ceremonies, Roles, Artefacts"]
            },
            {
                name: "Skills",
                items: ["Facilitate ceremonies", "Explain 'Why' for agile", "Teach methods", "Formulate artefacts"]
            },
            {
                name: "Values & Attitude",
                items: ["Reflect agile mindset", "Adapt methods to team needs", "Stimulate discussion on adaptation"]
            }
        ],
        tasks: [
            "Teaches the Scrum method and practices",
            "Supports formulating tasks",
            "Schedules Scrum meetings",
            "Facilitates Scrum meetings",
            "Stimulates discussion on how to adapt the Scrum method",
            "Brings new methods to the team",
            "Organizes team events"
        ]
    },
    {
        title: "Networker",
        description: "Connects the team inside and outside",
        categories: [
            {
                name: "Knowledge",
                items: ["Project organization setup", "Important stakeholders", "Important peers"]
            },
            {
                name: "Skills",
                items: ["Connect team with experts/stakeholders", "Support sprint review organization", "Knowledge sharing & peer groups", "Stakeholder management support"]
            },
            {
                name: "Values & Attitude",
                items: ["Coach other facilitators"]
            }
        ],
        tasks: [
            "Connects team members with relevant stakeholders, e.g. managers and/or experts, from within the organization",
            "Connects team members with relevant experts, e.g. from neighbouring departments or projects",
            "Connects team members with relevant stakeholders, e.g. managers and/or experts, from outside the organization",
            "Motivates team members to network with others"
        ]
    },
    {
        title: "Protector",
        description: "Shields the team from interference",
        categories: [
            {
                name: "Knowledge",
                items: ["Agile Manifesto", "Frameworks", "Ceremonies, Roles, Artefacts"]
            },
            {
                name: "Skills",
                items: ["Foster focus", "Identify inappropriate requests", "Shelter from PO/mgmt interference", "Staffing involvement"]
            },
            {
                name: "Values & Attitude",
                items: ["Argumentation skills", "Politics ;)"]
            }
        ],
        tasks: [
            "Shelters team from inappropriate requests from the Product Owner, managers, disciplinary leaders or other departments",
            "Protects team from re-prioritization",
            "Shelters team from management and Product Owner intervening in daily business",
            "Shelters team from management over-ruling decisions the team had come up with",
            "Protects team from re-staffing"
        ]
    },
    {
        title: "Moderator",
        description: "Facilitates understanding and decisions",
        categories: [
            {
                name: "Knowledge",
                items: ["Agile ceremonies", "Moderation methods", "Decision making methods"]
            },
            {
                name: "Skills",
                items: ["Organize workshops (standard & new)", "Communication", "Build bridges between perspectives", "Facilitate decision making", "Conflict moderation"]
            }
        ],
        tasks: [
            "Moderates discussions",
            "Builds a bridge between different perspectives and domains",
            "Helps to develop understanding each other properly",
            "Helps to develop tolerance towards different point of views",
            "Supports shared decision-making"
        ]
    },
    {
        title: "Disciplinizer on Equal Terms",
        description: "Holds the team accountable on eye-level",
        categories: [
            {
                name: "Knowledge",
                items: ["Values and principles (software/agile)"]
            },
            {
                name: "Skills",
                items: ["Facilitate team rules/values", "Communicate on eye level", "Support following agile values", "Meeting facilitation"]
            },
            {
                name: "Values & Attitude",
                items: ["Understand importance of values", "Resolve tense topics on eye level", "Role model in interpersonal self-efficacy"]
            }
        ],
        tasks: [
            "Supports team members to obey the rules the team agreed on",
            "Helps team members to focus on relevant topics",
            "Monitors tasks/progress",
            "Makes sure team members attend meetings",
            "Communicates on a par/on eye level"
        ]
    },
    {
        title: "Change Agent",
        description: "Drives organizational change and mindset",
        categories: [
            {
                name: "Knowledge",
                items: ["State-of-the-art product dev (Lean-agile, XOps, OKR)", "Failure culture", "Change management basics"]
            },
            {
                name: "Skills",
                items: ["Identify anti-patterns", "Accept failure & learn", "Prioritize needed changes"]
            },
            {
                name: "Values & Attitude",
                items: ["Role model", "Convince teams & mgmt of better ways", "Influence higher level decisions"]
            }
        ],
        tasks: [
            "Serves as a role model",
            "Convinces project teams of the agile way of working",
            "Influences decisions at higher level that support the team to work in an agile way",
            "Acquires needed resources",
            "Convinces management of the agile way of working",
            "Helps team members to accept failure and learn from it",
            "Helps team members to be open towards results"
        ]
    }
];
